export const Roles = Object.freeze({
	PUP: 'pick up point',
	CP: 'collectionorganization',
	RC: 'recycler',
	MF: 'brand',
	SD: 'storagedepot',
	NMSC: 'nmsc',
});
